var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBusiness = function SvgBusiness(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#111827",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M16.002 10h2.5m-2.5 3h2.5m-2.5 3.002h2.5M5.498 9.999h2.501M5.498 13h2.5m-2.5 3.002h2.5M10.5 13h3.002m-3.002 3.002h3.002m-3.002-6.003h3.002m-3.002-3.001h3.002M12 19.003v2m-4.002 0V3.998a1 1 0 0 1 1-1h6.003a1 1 0 0 1 1 1v17.007m5.003 0V7.91a.913.913 0 0 0-.914-.913h-4.088m-8.004 0H3.91a.913.913 0 0 0-.914.913v13.093m19.008 0H1.996"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBusiness);
export default ForwardRef;